import { CustomerTemplate } from "../../../src/types";
import {languages, checkLineCount, combineErrors, size, maxLineLength} from "./shared";
import { renderTemplate } from "../render";

export const boardCardTemplateData: CustomerTemplate = {
    key: 'boardCard',
    name: {
        de: 'Schwarzes Brett',
        en: 'Board'
    },
    width: 1024,
    height: 1024,
    scale: 1,
    languages,
    templateData: [
        {
            key: 'sucheOderBiete',
            name: {
                en: 'Type',
                de: 'Art'
            },
            languageData: {
                'de': 'Suche',
                'en': 'Suche'
            },
            maxLength: 10,
            fieldType: 'radio',
            options: ['Suche', 'Biete']
        },
        {
            key: 'description',
            name: {
                en: 'Description',
                de: 'Beschreibung'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 100,
            isValid: combineErrors([checkLineCount(2), maxLineLength(27)])
        },
        {
            key: 'name',
            name: {
                en: 'Name',
                de: 'Name'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 23,
            isValid: combineErrors([checkLineCount(1)])
        },
        {
            key: 'strasse',
            name: {
                en: 'Street',
                de: 'Straße'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 23,
            isValid: combineErrors([checkLineCount(1)])
        },
        {
            key: 'plzOrt',
            name: {
                en: 'ZIP / City',
                de: 'PLZ / Ort'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 21,
            isValid: combineErrors([checkLineCount(1)])
        },
        {
            key: 'tel',
            name: {
                en: 'Phone',
                de: 'Tel'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 26,
            isValid: combineErrors([checkLineCount(1)])
        },
        {
            key: 'email',
            name: {
                en: 'E-Mail',
                de: 'E-Mail'
            },
            languageData: {
                'de': '',
                'en': ''
            },
            maxLength: 23,
            isValid: combineErrors([checkLineCount(1)])
        }
    ],
    font: {
        headlineTop: {
            family: 'Poppins-Regular',
            color: '#000',
            size: 16,
            TopPadding: 140,
            lineHeight: 20
        },
        content: {
            family: 'Poppins-Regular',
            color: '#000',
            size: 16,
            TopPadding: 90,
            lineHeight: 20
        }
    },
}
